module.exports = __webpack_public_path__ + "img/411.b273504c.png";